import { render, staticRenderFns } from "./persons.vue?vue&type=template&id=72a57092"
import script from "./persons.vue?vue&type=script&lang=js"
export * from "./persons.vue?vue&type=script&lang=js"
import style0 from "./persons.vue?vue&type=style&index=0&id=72a57092&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports